<!--
 * @Author: qinmengyuan
 * @Date: 2024-08-16 14:50:08
 * @LastEditors: ttheitao
 * @LastEditTime: 2024-08-23 15:57:50
 * @FilePath: \onetab\src\components\ShareModal.vue
-->
<template>
  <RaDialog
    width="720px"
    :model-value="visible"
    :before-close="handleClose"
    :append-to-body="true"
    class="share-modal"
    :destroy-on-close="true"
    ><div class="container" v-loading="isLoading">
      <div class="modal-left">
        <div class="title">
          {{ type === 'share' ? '分类书签' : '保存书签' }}
        </div>
        <RaInput v-model="categoryKey" clearable />
        <div class="left-content">
          <RaCheckbox
            v-model="checkAll"
            :indeterminate="isIndeterminate"
            @change="handleCheckAllChange"
            >全选</RaCheckbox
          >
          <RaCheckboxGroup
            v-model="checkedCategories"
            @change="handleCheckedCategory"
          >
            <RaCheckbox
              v-for="item in categories.filter((cate) =>
                cate.name?.includes(categoryKey)
              )"
              :key="item"
              :label="item.uuid"
              :class="{ active: active === item.uuid }"
              :disabled="type !== 'share' && !item.is_share"
              @mouseenter="handleHover(item)"
              @mouseleave="showNum = false"
            >
              <div class="item-cont" @click.prevent="handleItem(item)">
                <div class="item">
                  <i :class="{ iconfont: true, [item.icon]: true }"></i>
                  {{ item.name }}
                </div>
                <div
                  class="num"
                  v-if="showNum === item.uuid || active === item.uuid"
                >
                  {{ active === item.uuid ? activeCheckNum : checkNum }}/{{
                    item.bookmarks?.length
                  }}
                </div>
              </div>
            </RaCheckbox>
          </RaCheckboxGroup>
        </div>

        <div class="desc" @click="listVisible = true" v-if="type === 'share'">
          我的分享
        </div>
      </div>
      <div class="modal-right">
        <RaIcon icon="Close" class="modal-close" @click="emits('close')" />
        <div class="title" v-show="leftType !== 'next'">
          <RaCheckbox
            v-show="leftType !== 'next'"
            v-model="checkChildrenAll"
            :indeterminate="isChildrenIndeterminate"
            @change="handleCheckChildrenAllChange"
            :disabled="childrenDisabled"
            >{{ activeTitle }}
          </RaCheckbox>
        </div>
        <div class="title" v-show="leftType === 'next'">{{ activeTitle }}</div>
        <div class="my-cate" v-show="leftType === 'next'">
          <div
            :class="{
              'my-item': true,
              active: !!activeCategories.find(
                (cate) => cate.uuid === item.uuid
              ),
            }"
            v-for="item in myCategories"
            :key="item.uuid"
            @click="handleMyCategory(item)"
          >
            <i :class="{ iconfont: true, [item.icon]: true }"></i
            >{{ item.name }}
            <RaIcon
              class="check"
              v-if="!!activeCategories.find((cate) => cate.uuid === item.uuid)"
              icon="Check"
            />
          </div>
        </div>
        <RaCheckboxGroup
          v-show="leftType !== 'next'"
          v-if="children.length"
          v-model="checkedChildren"
          @change="handleCheckedChildren"
        >
          <RaCheckbox
            v-for="item in children"
            :key="item.uuid"
            :label="item.uuid"
            :disabled="childrenDisabled"
          >
            <div class="item">
              <img v-if="item.icon" class="icon" :src="item.icon" alt="" />
              <div v-else class="icon" :style="{ background: item.color }">
                {{ item.name }}
              </div>
              <span class="type" v-if="item.type === 3">[小组件]</span>
              {{ item.name }}
            </div>
          </RaCheckbox>
        </RaCheckboxGroup>
        <div class="empty" v-else>
          <i class="iconfont icon-onetabsousuoshibai"></i>
          <div class="text">暂无数据</div>
        </div>
        <div class="btns">
          <RaButton
            type="neutral"
            class="btn"
            status="tertiary"
            @click="handleCancel"
            >{{ leftType === 'next' ? '上一步' : '取消' }}
          </RaButton>
          <RaButton
            type="primary"
            class="btn"
            status="main"
            :loading="shareLoading"
            @click="createShareLink"
            >{{
              type === 'share'
                ? '分享'
                : leftType === 'next'
                ? '保存'
                : '下一步'
            }}
          </RaButton>
        </div>
      </div>
    </div>
  </RaDialog>
  <ShareLinkPop
    :value="link"
    :visible="linkVisible"
    @close="linkVisible = false"
  />
  <ShareListModal :visible="listVisible" @close="listVisible = false" />
</template>

<script setup>
import { ref, onMounted, watch } from 'vue';

import {
  RaDialog,
  RaInput,
  RaCheckboxGroup,
  RaCheckbox,
  RaButton,
  RaMessage,
} from '@rafter/pc';
import { RaIcon } from '@rafter/icon';
import ShareLinkPop from './ShareLinkPop.vue';
import {
  addBookmark,
  addCategory,
  createShares,
  getCategoryList,
  getShareDetail,
} from '@/api/baseApi';
import { user } from '@/store/user';
import { bookmarks, refresh } from '@/store/bookmarks';
import ShareListModal from './ShareListModal.vue';
const emits = defineEmits(['close']);
const categoryKey = ref('');
const listVisible = ref(false);
const activeCategories = ref([]);
const shareLoading = ref(false);
const leftType = ref('normal');
const link = ref('');
const active = ref('');
const checkedCategories = ref([]);
const categories = ref([]);
const children = ref([]);
const checkChildrenAll = ref(false);
const isChildrenIndeterminate = ref(false);
const checkedChildren = ref([]);
const isLoading = ref(false);
const activeTitle = ref('');
const childrenDisabled = ref(false);
const myCategories = ref([]);
const showNum = ref(false);
const checkNum = ref(0);
const activeCheckNum = ref(0);
const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  type: {
    type: String,
    default: 'share',
  },
  code: {
    type: String,
    default: '',
  },
});
const linkVisible = ref(false);
const checkAll = ref(false);
const isIndeterminate = ref(false);
const handleCheckAllChange = (val) => {
  checkedCategories.value = val
    ? categories.value
        .filter((i) => i.is_share !== false)
        .map((item) => item.uuid)
    : [];
  isIndeterminate.value = false;
  childrenDisabled.value = checkedCategories.value.includes(active.value);
};
const handleCheckChildrenAllChange = (val) => {
  children.value.forEach((item) => {
    if (val) {
      if (!checkedChildren.value.includes(item.uuid)) {
        checkedChildren.value.push(item.uuid);
      }
    } else {
      checkedChildren.value = checkedChildren.value.filter(
        (checked) => checked !== item.uuid
      );
    }
  });
  if (val) {
    activeCheckNum.value = children.value.length;
  } else {
    activeCheckNum.value = 0;
  }
  isChildrenIndeterminate.value = false;
};
const handleCheckedCategory = (value) => {
  const checkedCount = value.length;
  checkAll.value = checkedCount === categories.value.length;
  isIndeterminate.value =
    checkedCount > 0 && checkedCount < categories.value.length;
  childrenDisabled.value = value.includes(active.value);
  checkedCategories.value.forEach((item) => {
    const bookmarks = categories.value.find(
      (cate) => cate.uuid === item
    ).bookmarks;
    const checkedMarks = checkedChildren.value.filter(
      (item) => !bookmarks.find((mark) => mark.uuid === item)
    );
    checkedChildren.value = checkedMarks;
  });
};
const handleCheckedChildren = (value) => {
  const checkedCount = value.length;
  checkChildrenAll.value = checkedCount === children.value.length;
  isChildrenIndeterminate.value =
    checkedCount > 0 && checkedCount < children.value.length;
  const item = categories.value.find((item) => item.uuid === active.value);
  let num = 0;
  const bookmarks = item.bookmarks;
  checkedChildren.value.forEach((item) => {
    if (bookmarks.find((mark) => mark.uuid === item)) {
      num += 1;
    }
  });
  activeCheckNum.value = num;
  if (
    activeCheckNum.value > 0 &&
    activeCheckNum.value < children.value.length
  ) {
    isChildrenIndeterminate.value = true;
  } else if (activeCheckNum.value === 0) {
    isChildrenIndeterminate.value = false;
    checkChildrenAll.value = false;
  } else {
    isChildrenIndeterminate.value = false;
    checkChildrenAll.value = true;
  }
};
const handleClose = () => {
  emits('close');
};
const handleItem = (item) => {
  active.value = item.uuid;
  children.value = item.bookmarks;
  activeTitle.value = item.name;
  let num = 0;
  const bookmarks = item.bookmarks;
  checkedChildren.value.forEach((item) => {
    if (bookmarks.find((mark) => mark.uuid === item)) {
      num += 1;
    }
  });
  activeCheckNum.value = num;
  if (num > 0 && num < children.value.length) {
    isChildrenIndeterminate.value = true;
  } else if (num === 0) {
    isChildrenIndeterminate.value = false;
    checkChildrenAll.value = false;
  } else {
    isChildrenIndeterminate.value = false;
    checkChildrenAll.value = true;
  }
  childrenDisabled.value = checkedCategories.value.includes(active.value);
};
const createShareLink = () => {
  if (props.type === 'share') {
    shareLoading.value = true;
    createShares({
      category_uuids: checkedCategories.value,
      bookmark_uuids: checkedChildren.value,
    })
      .then((res) => {
        if (+res.data.code === 200) {
          if (!window.location.href.includes('chrome-extension')) {
            link.value =
              window.location.href + 'share' + `?code=${res.data.data.code}`;
          } else {
            link.value =
              'https://mitab.bimcc.net/share' + `?code=${res.data.data.code}`;
          }
          linkVisible.value = true;
        } else {
          RaMessage.error('出错了');
        }
      })
      .catch(() => {
        RaMessage.error('出错了');
      })
      .finally(() => {
        shareLoading.value = false;
      });
  } else if (props.type === 'save') {
    if (leftType.value !== 'next') {
      leftType.value = 'next';
      activeTitle.value = '保存到';
      getCategoryList().then((res) => {
        myCategories.value = res.data.data;
      });
    } else {
      const checkedCateList = checkedCategories.value.map((item) =>
        categories.value.find((cate) => cate.uuid === item)
      );
      const promises = [];
      checkedCateList.forEach((item, index) => {
        const addCate = addCategory(
          {
            name: item.name,
            icon: item.icon,
            color: item.color,
            order: myCategories.value.length,
          },
          false
        ).then((res) => {
          item.bookmarks.forEach((mark, m) => {
            const addBook = addBookmark(
              {
                type: mark.type,
                name: mark.name,
                url: mark.url,
                category_uuid: res.uuid,
                icon: mark.icon,
                order: m,
                color: mark.color,
                describe: mark.describe,
              },
              index === checkedCateList.length - 1 &&
                m === item.bookmarks?.length - 1
            );
            promises.push(addBook);
          });
        });
        promises.push(addCate);
      });
      const checkChildrenItems = checkedChildren.value.map((item) => {
        let mark;
        categories.value.forEach((cate) => {
          if (cate.bookmarks?.find((b) => b.uuid === item)) {
            mark = cate.bookmarks?.find((b) => b.uuid === item);
          }
        });
        return mark;
      });
      if (checkChildrenItems.length) {
        if (!activeCategories.value.length) {
          RaMessage.warning('请选择要保存到的分类！');
        } else {
          activeCategories.value.forEach((cate, index) => {
            checkChildrenItems.forEach((mark, m) => {
              const isSync = index === activeCategories.value.length - 1 && m === checkChildrenItems?.length - 1;
              const addBook = addBookmark(
                {
                  type: mark.type,
                  name: mark.name,
                  url: mark.url,
                  category_uuid: cate.uuid,
                  icon: mark.icon,
                  order: cate.bookmarks?.length,
                  color: mark.color,
                  describe: mark.describe,
                },
                isSync
              ).then(res=>{
                if(isSync){
                  refresh();
                }
              });
              promises.push(addBook);
            });
          });
        }
      }
      Promise.all(promises)
        .then(() => {
          RaMessage.success('保存成功！');
          emits('close');
        })
        .catch((error) => {
          console.error('One of the promises failed:', error);
        });
    }
  }
};
watch(
  () => props.visible,
  () => {
    if (props.visible && !props.code) {
      isLoading.value = true;
      getCategoryList()
        .then((res) => {
          if (+res.data.code === 200) {
            categories.value = res.data.data;
            activeTitle.value = res.data.data[0].name;
            children.value = res.data.data[0]?.bookmarks;
            active.value = res.data.data[0]?.uuid;
          } else {
            RaMessage.error('出错了！');
          }
        })
        .catch(() => {
          RaMessage.error('出错了！');
        })
        .finally(() => {
          isLoading.value = false;
        });
    }
    if (props.code) {
      isLoading.value = true;
      getShareDetail(props.code)
        .then((res) => {
          if (+res.data.code === 200) {
            categories.value = res.data.data.categories;
            children.value = res.data.data.categories[0].bookmarks;
            active.value = res.data.data.categories[0]?.uuid;
            activeTitle.value = res.data.data.categories[0].name;
          }
        })
        .finally(() => {
          isLoading.value = false;
        });
    }
    if (!props.visible) {
      checkAll.value = false;
      checkChildrenAll.value = false;
      isIndeterminate.value = false;
      isChildrenIndeterminate.value = false;
      checkedCategories.value = [];
      checkedChildren.value = [];
      childrenDisabled.value = false;
      myCategories.value = [];
      showNum.value = false;
      checkNum.value = 0;
      activeCheckNum.value = 0;
      leftType.value = 'normal';
      activeCategories.value = [];
      categoryKey.value = '';
    }
  }
);
const handleCancel = () => {
  if (leftType.value === 'next') {
    leftType.value = 'normal';
  } else {
    emits('close');
  }
};
const handleMyCategory = (cate) => {
  if (activeCategories.value.find((item) => item.uuid === cate.uuid)) {
    activeCategories.value = activeCategories.value.filter(
      (item) => item.uuid !== cate.uuid
    );
  } else {
    activeCategories.value.push(cate);
  }
};

const handleHover = (item) => {
  checkNum.value = 0;
  showNum.value = item.uuid;
  const bookmarks = item.bookmarks;
  checkedChildren.value.forEach((item) => {
    if (bookmarks.find((mark) => mark.uuid === item)) {
      checkNum.value += 1;
    }
  });
};
</script>
<style lang="scss">
.share-modal {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin: 0 !important;
  border-radius: 24px !important;
  height: 560px;
  @include background_color('base-bg-color-09');
  backdrop-filter: blur(40px);
  .ra-dialog__header {
    display: none !important;
  }

  .ra-dialog__body {
    padding: 0 !important;
  }
  .container {
    display: flex;
    width: 100%;
    height: 100%;
  }
  .modal-left {
    padding: 16px;
    width: 184px;
    height: -webkit-fill-available;
    @include background_color('background-overlay');
    display: flex;
    flex-direction: column;
    gap: 16px;
    .title {
      @include font_color('text-on-surface-secondary');
      font-family: 'PingFang SC';
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 24px; /* 150% */
      margin-left: 4px;
    }
    .left-content {
      flex: 1;
      .ra-checkbox {
        padding: 0 10px;
        border-radius: 6px;
      }
      .ra-checkbox__label {
        @include font_color('text-on-surface-secondary');
        font-family: 'PingFang SC';
        font-size: 13px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px; /* 153.846% */
        margin-left: 4px;
        flex: 1;
      }
      .ra-checkbox-group {
        display: flex;
        flex-direction: column;
        .ra-checkbox {
          &:hover {
            @include background_color('background-overlay');
          }
          .ra-checkbox__label {
            .item-cont {
              display: flex;
              align-items: center;
              justify-content: space-between;
            }
            .item {
              padding: 6px 0;
              display: flex;
              align-items: center;
              .iconfont {
                font-size: 24px;
              }
            }
            .num {
              display: flex;
              align-items: center;
            }
          }
        }
        .active {
          @include background_color('background-overlay');
        }
      }
    }
    .desc {
      display: flex;
      height: var(--button-list-field-medium, 32px);
      padding: 6px 10px;
      align-items: center;
      gap: 4px;
      align-self: stretch;
      @include font_color('text-on-surface-secondary');
      font-family: 'PingFang SC';
      font-size: 13px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px; /* 153.846% */
      cursor: pointer;
      user-select: none;
    }
  }
  .modal-right {
    padding: 16px 20px;
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 16px;
    position: relative;
    .modal-close {
      position: absolute;
      right: 18px;
      top: 14px;
      font-size: 16px;
      width: 32px;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 4px;
      @include font_color('text-on-surface-secondary');
      &:hover {
        background: #f4f6f9;
      }
    }
    .ra-checkbox {
      padding: 0 12px;
    }
    .title {
      @include font_color('text-on-surface-secondary');
      font-family: 'PingFang SC';
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 24px; /* 150% */
      height: 24px;
      .ra-checkbox {
        height: 24px;
        .ra-checkbox__label {
          @include font_color('text-on-surface-secondary');
          font-family: 'PingFang SC';
          font-size: 16px;
          font-style: normal;
          font-weight: 500;
          line-height: 24px; /* 150% */
        }
      }
    }
    .empty {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 16px;
      .iconfont {
        font-size: 90px;
        height: 50px;
        @include font_color('text-on-surface-primary');
      }
      .text {
        @include font_color('text-on-surface-primary');
      }
    }

    .ra-checkbox-group,
    .my-cate {
      flex: 1;
      display: flex;
      flex-direction: column;
      gap: 8px;
      overflow-y: scroll;
      &::-webkit-scrollbar {
        display: none;
      }

      /* 隐藏滚动条轨道 */
      &::-webkit-scrollbar-track {
        display: none;
      }

      /* 隐藏滚动条滑块 */
      &::-webkit-scrollbar-thumb {
        display: none;
      }
      .ra-checkbox,
      .my-item {
        height: 40px;
        border-radius: 8px;
        @include background_color('base-bg-color-09');
        flex-shrink: 0;
        .item {
          display: flex;
          align-items: center;
          gap: 6px;
          @include font_color('text-on-surface-secondary');
          .icon {
            width: 24px;
            height: 24px;
            border-radius: 4px;
            margin-right: 6px;
            display: flex;
            align-items: center;
            @include font_color('base-bg-color-09');
            overflow: hidden;
            box-sizing: border-box;
          }
          .type {
            color: var(--semantic-caution-on-background, #c59715);
            text-align: center;
            font-family: 'PingFang SC';
            font-size: 13px;
            font-style: normal;
            font-weight: 400;
            line-height: 20px;
          }
        }
      }
      .my-item {
        display: flex;
        align-items: center;
        padding: 0 12px;
        background: transparent;
        position: relative;
        @include font_color('text-on-surface-secondary');
        .iconfont {
          font-size: 24px;
        }
        .check {
          position: absolute;
          color: #007aff;
          font-size: 20px;
          right: 12px;
        }
        &:hover {
          @include background_color('base-bg-color-09');
        }
      }
      .active {
        @include background_color('base-bg-color-09');
      }
    }
    .btns {
      display: flex;
      justify-content: center;
      gap: 16px;
      .btn {
        width: 128px;
      }
      .tertiary-class {
        @include background_color('base-bg-color-09');
      }
    }
  }
}
.ra-loading-mask {
  background-color: transparent !important;
}
</style>
